export function parseUnknownDef() {
    return {};
}
//# sourceMappingURL=unknown.mjs.map